import { localStorageSubtitleId } from './constants';
import { isGenreMatch } from './helpers';

export function disableAds(disableArray, progArr){
	let disable = 0;

//	if (disableArray && disableArray.length > 0) {
		if ( disableArray.some( e => progArr.includes(e) ) ) {
			disable = 1;
		}
//	}

	return disable;
}

export function stingAds(stingSeries, stingProgramme, stingCat, series_id, programme_id, cat_id){
    let stingId = 0;

    if(stingSeries && Object.keys(stingSeries).length > 0) {
				stingId = stingProgramme.includes(programme_id) ? programme_id : stingSeries.includes(series_id) ? series_id : 0;
    }

		//If there is no programme/series sting check if there is a category sting
		if(stingId === 0) {
			if(stingCat && stingCat.length > 0) {
				let genreIds = [];
				for (let i = 0; i < stingCat.length; i++) {
					if(isGenreMatch(cat_id, stingCat[i])) {
						genreIds.push(stingCat[i]);
					}
				}
				stingId = genreIds[Math.floor(Math.random() * genreIds.length)];
			}
		}

	return stingId;
}

export const isVideoPlayerInstance = () => {
    return window.playerOptions && window.playerOptions.video_id;
}

export const getPlayerTextTracks = () => {
	 return isVideoPlayerInstance() ? window.videojs(window.playerOptions.video_id).textTracks() : [];
}

export function setSubtitleId(subtitleId=0) {
	localStorage.setItem(localStorageSubtitleId, subtitleId);
}

export function getSubtitleId() {
	if(!localStorage.getItem(localStorageSubtitleId) || localStorage.getItem(localStorageSubtitleId) === null) {
		localStorage.setItem(localStorageSubtitleId, 0);
	}

	return localStorage.getItem(localStorageSubtitleId);
}
